// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c96ca4b5","85":"2ea28260","300":"63463484","367":"3fba698a","411":"a87625db","432":"344f3994","453":"80277a13","497":"c8903e8c","752":"46ac45a9","777":"65980cdf","952":"dfb2b86a","999":"63e627cb"}[chunkId] + ".chunk.js";
};